var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0802 7.92889C17.0802 8.44666 17.5 8.86639 18.0177 8.86639L21.1335 8.86639V11.9822C21.1335 12.5 21.5533 12.9197 22.071 12.9197C22.5888 12.9197 23.0085 12.5 23.0085 11.9822V7.92889C23.0085 7.41113 22.5888 6.9914 22.071 6.99139L18.0177 6.99139C17.5 6.99139 17.0802 7.41113 17.0802 7.92889Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.071 17.0802C21.5533 17.0802 21.1335 17.5 21.1335 18.0177L21.1335 21.1335L18.0177 21.1335C17.4999 21.1335 17.0802 21.5533 17.0802 22.071C17.0802 22.5888 17.4999 23.0085 18.0177 23.0085L22.071 23.0085C22.5888 23.0085 23.0085 22.5888 23.0085 22.071V18.0177C23.0085 17.5 22.5888 17.0802 22.071 17.0802Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.9289 17.0802C8.44666 17.0802 8.8664 17.5 8.8664 18.0177L8.8664 21.1335L11.9822 21.1335C12.5 21.1335 12.9197 21.5533 12.9197 22.071C12.9197 22.5888 12.5 23.0085 11.9822 23.0085L7.9289 23.0085C7.41113 23.0085 6.9914 22.5888 6.9914 22.071L6.9914 18.0177C6.9914 17.5 7.41113 17.0802 7.9289 17.0802Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9197 7.92889C12.9197 8.44666 12.4999 8.86639 11.9822 8.86639L8.86636 8.86639L8.86636 11.9822C8.86636 12.5 8.44663 12.9197 7.92886 12.9197C7.4111 12.9197 6.99136 12.5 6.99136 11.9822L6.99136 7.92889C6.99136 7.41113 7.4111 6.99139 7.92886 6.99139L11.9822 6.99139C12.4999 6.99139 12.9197 7.41113 12.9197 7.92889Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExpand);
export default __webpack_public_path__ + "static/media/icon_expand.56b872d3aee3bb99c01b3e6d185bed7a.svg";
export { ForwardRef as ReactComponent };